import core from "@/helpers/client";

const userService = {
  async GetMeAsync() {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_API}api/v1/me`
    )
    return result
  }
};
export default userService;
